import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import { Header } from '@finder/shared/services/header-alignment/header-alignment.interface';
import { HeaderAlignmentService } from '@finder/shared/services/header-alignment/header-alignment.service';

@Directive({
    selector: '[finderAlignHeader]',
    standalone: true
})
export class AlignHeaderDirective implements AfterViewInit {
    data: any;
    header: Header;

    @Input()
    set finderAlignHeader(data: any) {
        this.data = data;
    }
    @Input('finderAlignHeaderIsSubtitle') isSubtitle = false;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private headerAlignmentService: HeaderAlignmentService
    ) {}

    ngAfterViewInit(): void {
        // If it does not have alignment properties,
        // so we avoid to affect previous features
        const hasAlignmentProperties = Object.keys(this.data).find((key) => key.includes('Alignment'));

        if (!hasAlignmentProperties) {
            return;
        }
        // We get the header properties processed by the headerAlignment service
        // Then decide if it is title or subtitle,
        // Then add the proper class to the element.
        this.header = this.headerAlignmentService.getHeaderAlignment(this.data);
        const desktopAlignment = this.isSubtitle ? this.header.subtitleAlignment : this.header.titleAlignment;
        const mobileAlignment = this.isSubtitle ? this.header.mobileSubtitleAlignment : this.header.mobileTitleAlignment;

        const desktopClass = `header-desktop-${desktopAlignment}`;
        const mobileClass = `header-mobile-${mobileAlignment}`;

        const el: HTMLElement = this.elementRef.nativeElement;

        this.renderer.addClass(el, desktopClass);
        this.renderer.addClass(el, mobileClass);
    }
}
